export default "__VITE_ASSET__DSIn028q__"